import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import { apiClient } from '../../api_actions/index';
import { useState, useEffect, useRef } from 'react';
import LogoCell from '../../components/LogoCell/LogoCell.jsx';

export default function CustomersPage() {
  const [customerLogoUrl, setCustomerLogoUrl] = useState(null);
  const columns = [
    {
      title: 'Customer Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: 'Logo',
      dataIndex: 'logo_asset_id',
      key: 'logo_asset_id',
      render: (logo_asset_id) => <LogoCell id={logo_asset_id}/>
    },
    // Removed logos for now as they aren't loading
    // { title: 'Logo', dataIndex: 'logo', key: 'logo' },
  ];

  const formFields = [
    {
      name: 'customer_id',
      label: 'Customer ID',
      type: 'textarea',
      placeholder: 'Customer ID',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Customer Name',
      type: 'textarea',
      placeholder: 'Customer Code',
      rules: [{ required: true, message: 'Must Enter a Customer Name!' }]
    },
    {
      name: 'logo_asset_id',
      label: 'Logo',
      type: 'imageSelect',
      optionsEndpoint: '/read/logos',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'id',
      searchable: true,
      rules: [{ required: true }],
    },
    {
      name: 'small_logo_asset_id',
      label: 'Small Logo',
      type: 'imageSelect',
      optionsEndpoint: '/read/logos',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'id',
      searchable: true,
      rules: [{ required: true }],
    },
    {
      name: 'color',
      label: 'Color',
      type: 'color',
      placeholder: 'Detection Package Color',
    },
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/customers"
        readEndpoint="read/customers"
        editEndpoint="update/customers"
        deleteEndpoint="delete/customers"
        columns={columns}
        formFields={formFields}
        title="Customers"
      />
    </div>
  );
}